"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchExtensions = fetchExtensions;
exports.createInvoice = exports.fetchCustomersWithQuery = exports.fetchSummariesForDeal = exports.fetchProductsByName = exports.fetchProductsByPartialName = exports.fetchTerms = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _immutable = require("immutable");

var _omit = _interopRequireDefault(require("transmute/omit"));

var _pick = _interopRequireDefault(require("transmute/pick"));

var _AccountingExtension = _interopRequireDefault(require("../model/AccountingExtension"));

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _makeBatch = _interopRequireDefault(require("crm_data/api/makeBatch"));

var _AccountingCustomer = _interopRequireWildcard(require("../model/AccountingCustomer"));

var _AccountingProduct = _interopRequireDefault(require("../model/AccountingProduct"));

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _AccountingTerms = _interopRequireDefault(require("../model/AccountingTerms"));

var _AccountingInvoiceSummary = _interopRequireDefault(require("../model/AccountingInvoiceSummary"));

var baseUrl = 'accountingextension/v1';

function fetchExtensions() {
  return (0, _ImmutableAPI.get)(baseUrl + "/integrations").then(function (extensions) {
    return extensions.map(function (response) {
      return new _AccountingExtension.default(response);
    });
  });
}

var fetchTerms = (0, _makeBatch.default)(function (key) {
  var extensionId = key.get('extensionId');
  var accountId = key.get('accountId');
  return (0, _ImmutableAPI.get)(baseUrl + "/product/terms", {
    accountId: accountId,
    extensionId: extensionId
  }).then(function (terms) {
    return (0, _immutable.List)(terms.map(function (response) {
      return new _AccountingTerms.default(response);
    }));
  });
}, 'AccountingExtensionsAPI.fetchTerms');
exports.fetchTerms = fetchTerms;
var fetchProductsByPartialName = (0, _makeBatch.default)(function (key) {
  var extensionId = key.get('extensionId');
  var accountId = key.get('accountId');
  var query = key.get('query');
  return (0, _ImmutableAPI.send)({
    type: _HTTPVerbs.POST
  }, baseUrl + "/product/search", {
    accountId: accountId,
    appId: extensionId,
    searchRequests: _immutable.List.of((0, _immutable.Map)({
      query: query.trim(),
      fieldType: 'NAME_PARTIAL'
    }))
  }).then(function (products) {
    return (0, _immutable.List)(products.map(function (response) {
      return new _AccountingProduct.default(response);
    }));
  });
}, 'AccountingExtensionsAPI.fetchProductsByPartialName');
exports.fetchProductsByPartialName = fetchProductsByPartialName;
var fetchProductsByName = (0, _makeBatch.default)(function (key) {
  var extensionId = key.get('extensionId');
  var accountId = key.get('accountId');
  var names = key.get('names') && key.get('names').map(function (name) {
    return (0, _immutable.Map)({
      query: name.trim(),
      fieldType: 'NAME_FULL'
    });
  });
  return (0, _ImmutableAPI.send)({
    type: _HTTPVerbs.POST
  }, baseUrl + "/product/search", {
    accountId: accountId,
    appId: extensionId,
    searchRequests: names
  }).then(function (products) {
    return (0, _immutable.List)(products.map(function (response) {
      return new _AccountingProduct.default(response);
    }));
  });
}, 'AccountingExtensionsAPI.fetchProducts');
exports.fetchProductsByName = fetchProductsByName;

var fetchSummariesForDeal = function fetchSummariesForDeal(dealId) {
  return (0, _ImmutableAPI.get)(baseUrl + "/invoice/for-deal/" + dealId).then(function (response) {
    return response.get('invoices').map(function (invoiceSummary) {
      var dueDateArray = invoiceSummary.get('dueDate').toArray();
      return invoiceSummary.set('dueDate', new Date(dueDateArray[0], dueDateArray[1] - 1, dueDateArray[2]));
    }).map(function (invoiceSummary) {
      return new _AccountingInvoiceSummary.default(invoiceSummary);
    });
  });
};

exports.fetchSummariesForDeal = fetchSummariesForDeal;
var fetchCustomersWithQuery = (0, _makeBatch.default)(function (key) {
  var extensionId = key.get('extensionId');
  var accountId = key.get('accountId');
  var searchRequests = key.get('searchRequests');
  return (0, _ImmutableAPI.send)({
    type: _HTTPVerbs.POST
  }, baseUrl + "/customer/search", {
    appId: extensionId,
    accountId: accountId,
    searchRequests: searchRequests
  }).then(function (customers) {
    return (0, _immutable.List)(customers.map(function (customer) {
      return new _AccountingCustomer.default(customer);
    }));
  });
}, 'AccountingExtensionsAPI.fetchCustomersWithQuery');
exports.fetchCustomersWithQuery = fetchCustomersWithQuery;

var createInvoice = function createInvoice(_ref) {
  var invoice = _ref.invoice,
      customer = _ref.customer;
  var requestBody = (0, _extends2.default)({
    invoiceCreationRequest: (0, _extends2.default)({}, (0, _omit.default)(['appId', 'accountName', 'accountId'], invoice.toJS())),
    customerCreationRequest: null
  }, (0, _pick.default)(['appId', 'accountId', 'accountName'], invoice.toJS()));

  if (customer.id === _AccountingCustomer.CREATE_CUSTOMER_ID) {
    requestBody.invoiceCreationRequest.customerId = null;
    requestBody.customerCreationRequest = (0, _extends2.default)({}, (0, _omit.default)(['id'], customer.toJS()));
  }

  return (0, _ImmutableAPI.send)({
    type: _HTTPVerbs.POST,
    dataType: 'text'
  }, baseUrl + "/invoice/create-with-customer", requestBody, function (shareLink) {
    return shareLink;
  });
};

exports.createInvoice = createInvoice;